// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23G0Q","comment":"styles_comment__949du"};